import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { API, mediaUrl } from "@/lib/api";
import useSEO from "@/hooks/useSEO";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useSEO({ title: item?.seo_title || item?.title, description: item?.seo_meta_description || item?.summary });

  useEffect(() => {
    axios.get(`${API}/content/articles/${slug}`)
      .then(r => setItem(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="container-wide py-24" data-testid="article-not-found">
        <h1 className="font-heading text-4xl" style={{ color: "var(--gi-maroon)" }}>Article not found</h1>
        <p className="mt-4 text-sm" style={{ color: "var(--gi-muted)" }}>The article you are looking for is not currently published.</p>
        <Link to="/articles" className="btn-ghost mt-6" data-testid="article-back-btn"><ArrowLeft size={12} /> Back to articles</Link>
      </div>
    );
  }
  if (!item) return <div className="container-wide py-24 font-heading text-2xl" data-testid="article-loading">Loading…</div>;

  return (
    <div data-testid="article-detail">
      <section className="container-wide pt-12 pb-6">
        <Link to="/articles" className="btn-ghost" data-testid="article-back-btn"><ArrowLeft size={12} /> Articles</Link>
      </section>
      <article className="container-narrow py-8">
        <div className="font-accent text-[10px]" style={{ color: "var(--gi-gold)" }}>{item.category || "Article"}</div>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl leading-[1.05]" style={{ color: "var(--gi-maroon)" }} data-testid="article-title">{item.title}</h1>
        <div className="mt-3 text-xs" style={{ color: "var(--gi-muted)" }}>
          {[item.author, item.published_at && new Date(item.published_at).toLocaleDateString(), item.reading_time].filter(Boolean).join(" · ")}
        </div>
        <div className="hair-divider my-8 max-w-xs" />
        {item.featured_image && (
          <img src={mediaUrl(item.featured_image)} alt={item.title} className="w-full max-h-[420px] object-cover border mb-8" style={{ borderColor: "var(--gi-border)" }} />
        )}
        {item.body ? (
          <div className="article-body text-base leading-relaxed" style={{ color: "var(--gi-charcoal)" }}>
            {item.body.split(/\n\n+/).map((para, i) => (
              <p key={`p-${i}`} className="mb-4">{para}</p>
            ))}
          </div>
        ) : (
          <p className="text-sm p-4 border-l-2" style={{ borderColor: "var(--gi-gold)", background: "var(--gi-ivory-2)", color: "var(--gi-charcoal-2)" }} data-testid="article-body-missing">
            The full text of this article is being prepared for publication.
          </p>
        )}
      </article>
    </div>
  );
}
